import React, { useEffect, useState } from "react";
import { Form, Button, Modal, Popconfirm } from "antd";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";

import ListContainer from "../../modules/group/containers/List";
import GroupsTable from "../Table/Groups";
import GroupForm from "../Forms/Groups/Group";
import InviteUserForm from "../Forms/Groups/InviteUser";
import withPage from "./withPage";
import { PAGE_SIZE } from "../../constants";
import RoutePlanCurrent from "../RoutePlan/RoutePlanCurrent";
import PrimaryButton from "../Buttons/PrimaryButton";
import { getTranslation } from "../../utils/helper";

const GroupsPage = ({
  isFetching,
  isSucceeded,
  groups,
  invite,
  metadata,
  query,
  pushTo,
  doGetAllGroups,
  doCreateGroup,
  doUpdateGroup,
  doDeleteGroup,
  doUpdateGroupInviteEmail,
  doUpdateGroupDisInviteEmail,
  doGetGroupInviteEmails,
  doOffGroupInviteEmails,
}) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  const [form] = Form.useForm();
  const currentPage = Number(query.currentPage) || 1;
  const itemsPerPage = Number(query.itemsPerPage) || PAGE_SIZE;
  const pagination = {
    current: currentPage,
    pageSize: itemsPerPage,
    total: metadata.totalItems,
    showTotal: total => `${total} ${getTranslation(setting, "User Groups", "User Groups")}`,
  };

  const [state, setState] = useState({
    visibleModal: false,
    action: "",
    type: "",
    group: null,
  });

  const [hidePopup, setHidePopup] = useState(false);

  useEffect(() => {
    if (!isFetching && isSucceeded && hidePopup) {
      handleCancel();
      setTimeout(() => {
        setHidePopup(false);
      }, 2000);
    }
  }, [isFetching]);

  useEffect(() => {
    doGetAllGroups({ currentPage, itemsPerPage, ...query });
  }, []);

  const handleFilter = (params, updatePath) => {
    if (updatePath) {
      pushTo({ query: params });
    }
    const currentPage = Number(params.currentPage) || 1;
    const itemsPerPage = Number(params.itemsPerPage) || PAGE_SIZE;
    doGetAllGroups({
      currentPage,
      itemsPerPage,
      ...params,
    });
  };

  const handleTableChange = params => {
    handleFilter(params, true);
  };

  const withAction = item => {
    return (
      <div className="actions">
        <Button
          type="link"
          className="invite-user"
          onClick={() => {
            handleClickActionInviteUser(item);
          }}>
          {getTranslation(setting, "User Groups", "Invite")}
          <ReactSVG className="icon invite-user" src="/icons/invite-user.svg" />
        </Button>
        <Button
          type="link"
          className="edit"
          onClick={() => {
            handleClickAction("edit", item);
          }}>
          <ReactSVG className="icon edit" src="/icons/edit.svg" />
        </Button>
        <Popconfirm
          title={getTranslation(setting, "Common", "Are you sure to delete this item?")}
          onConfirm={() => handleClickDelete(item)}
          okText={getTranslation(setting, "Common", "Yes")}
          cancelText={getTranslation(setting, "Common", "No")}>
          <Button type="link" className="delete">
            <ReactSVG className="icon delete" src="/icons/delete.svg" />
          </Button>
        </Popconfirm>
      </div>
    );
  };

  const handleClickDelete = async item => {
    await doDeleteGroup(item._id);
    await doGetAllGroups({ currentPage, itemsPerPage, ...query });
  };

  const handleClickAction = (action, item) => {
    console.log("hereeeee");
    form.setFieldsValue({
      name: item?.name,
    });
    setState({
      ...state,
      action,
      type: "group",
      group: item,
      visibleModal: true,
    });
  };

  const handleClickActionInviteUser = async group => {
    setState({
      ...state,
      type: "invite",
      group: group,
      visibleModal: true,
    });
  };

  const handleOnFinish = async values => {
    setHidePopup(true);
    if (state.group) {
      await doUpdateGroup({ id: state.group._id, ...values });
    } else {
      await doCreateGroup(values);
      await doGetAllGroups({ currentPage, itemsPerPage, ...query });
    }
  };

  const handleCancel = () => {
    setState({ ...state, visibleModal: false });
    form.resetFields();
  };

  return (
    <div className="Content GroupsPage">
      <RoutePlanCurrent />
      <div className="ContentHeader">
        <div className="HeaderTitle">{getTranslation(setting, "User Groups", "User Groups")}</div>
        <div className="HeaderToolBar   ">
          <div className="ToolBarButtons">
            <Button className="FilterButton" type="primary">
              {getTranslation(setting, "Common", "Filter")}
              <ReactSVG className="icon filter" src="/icons/filter.svg" />
            </Button>
            <PrimaryButton
              label={getTranslation(setting, "User Groups", "New Group")}
              className="NewButton"
              icon={<ReactSVG className="icon" src="/icons/add.svg" />}
              onClick={() => {
                handleClickAction("new", null);
              }}
            />
          </div>
        </div>
      </div>
      <div className="ContentMain">
        <GroupsTable
          rowKey="_id"
          loading={isFetching}
          query={query}
          withAction={withAction}
          pagination={pagination}
          dataSource={groups}
          onChange2={handleTableChange}
          scrollHeight="calc(100vh - 285px)"
          actionWidth={180}
          setting={setting}
        />
      </div>

      <Modal open={state.visibleModal} onCancel={handleCancel} footer={[]} width={600}>
        {state.type === "group" && (
          <GroupForm
            form={form}
            isFetching={isFetching}
            group={state.group}
            handleSubmit={handleOnFinish}
            handleCancel={handleCancel}
          />
        )}
        {state.type === "invite" && (
          <InviteUserForm
            form={form}
            isFetching={isFetching}
            group={state.group}
            invite={invite}
            doGetGroupInviteEmails={doGetGroupInviteEmails}
            doUpdateGroupInviteEmail={doUpdateGroupInviteEmail}
            doUpdateGroupDisInviteEmail={doUpdateGroupDisInviteEmail}
            doOffGroupInviteEmails={doOffGroupInviteEmails}
          />
        )}
      </Modal>
    </div>
  );
};

export default withPage(ListContainer(GroupsPage));
